import DynamiteAnim from './DynamiteAnim';

export default DynamiteAnim;
